
import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../../pages/Dashboard";

// Lazy load other pages for better performance
const Auth = React.lazy(() => import("../../pages/Auth"));
const Animals = React.lazy(() => import("../../pages/Animals"));
const AnimalDetails = React.lazy(() => import("../../pages/AnimalDetails"));
const NewAnimal = React.lazy(() => import("../../pages/NewAnimal"));
const EditAnimal = React.lazy(() => import("../../pages/EditAnimal"));
const NewEvent = React.lazy(() => import("../../pages/NewEvent"));
const Account = React.lazy(() => import("../../pages/Account"));
const ProfileInformation = React.lazy(() => import("../../pages/ProfileInformation"));
const Settings = React.lazy(() => import("../../pages/Settings"));
const PlanAndBilling = React.lazy(() => import("../../pages/PlanAndBilling"));
const NotFound = React.lazy(() => import("../../pages/NotFound"));

const AppRoutes: React.FC = () => {
  console.log('[AppRoutes] Rendering routes');
  
  // Simple loading fallback
  const LoadingFallback = () => (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <div className="w-8 h-8 border-3 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600 text-sm">Loading page...</p>
      </div>
    </div>
  );
  
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/animals" element={<Animals />} />
        <Route path="/animals/new" element={<NewAnimal />} />
        <Route path="/animals/:id" element={<AnimalDetails />} />
        <Route path="/animals/:id/edit" element={<EditAnimal />} />
        <Route path="/animals/:id/events/new" element={<NewEvent />} />
        <Route path="/events/new" element={<NewEvent />} />
        <Route path="/account" element={<Account />} />
        <Route path="/account/profile" element={<ProfileInformation />} />
        <Route path="/account/settings" element={<Settings />} />
        <Route path="/account/billing" element={<PlanAndBilling />} />
        
        {/* Root path - redirect to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        
        {/* Catch all unknown routes */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
